import React, { useEffect, useState, useCallback } from 'react';
import PropTypes from 'prop-types';

import { removeDuplicates } from 'utils/removeDuplicates';

import errorIcon from 'assets/icons/error-icon.svg';
import trashIcon from 'assets/icons/trash.svg';
import loadingIcon from 'assets/icons/spinner.svg';
import closeIcon from 'assets/icons/close.svg';
import checkCircleIcon from 'assets/icons/check-circle.svg';
import hourGlassIcon from 'assets/icons/whitehourglass-icon.svg';
import emailIcon from 'assets/icons/email-icon-w.svg';

import {
  StyledToast,
  StyledIconAction,
  StyledButton,
  StyledCloseBtn,
  StyledToastContainer,
  StyledToastSeparator,
  StyledToastColumn,
} from './styled';

import { useToast } from 'hooks/useToast';

const Toast = props => {
  const { toastList: propsToastList, autoDelete, dismissTime } = props;

  // ✅ SEMPRE chama
  const { toastList: contextToastList, setToastList } = useToast();

  const isUsingProps = propsToastList !== undefined;

  const sourceList = isUsingProps ? propsToastList : contextToastList;

  const [list, setList] = useState([]);

  useEffect(() => {
    const filtered = removeDuplicates(sourceList || [], 'id');
    setList(filtered);
  }, [sourceList]);

  const deleteToast = useCallback(
    id => {
      setList(prev => prev.filter(t => t.id !== id));

      // 👇 só remove global se estiver usando contexto
      if (!isUsingProps && setToastList) {
        setToastList(prev => prev.filter(t => t.id !== id));
      }
    },
    [isUsingProps, setToastList],
  );

  useEffect(() => {
    const interval = setInterval(() => {
      if (!list.length) return;

      const firstToast = list[0];
      if (!firstToast) return;

      if (firstToast.type === 'loading') return;

      const shouldAutoDelete = firstToast.autoDelete !== undefined ? firstToast.autoDelete : autoDelete;

      if (!shouldAutoDelete) return;

      deleteToast(firstToast.id);
    }, dismissTime);

    return () => clearInterval(interval);
  }, [list, autoDelete, dismissTime, deleteToast]);

  const handleIconByType = type => {
    switch (type) {
      case 'emailConfirmation':
        return emailIcon;
      case 'info':
        return trashIcon;
      case 'loading':
        return loadingIcon;
      case 'success':
        return checkCircleIcon;
      case 'darkSuccess':
        return checkCircleIcon;
      case 'warning':
        return null;
      case 'error':
        return errorIcon;
      case 'trash':
        return trashIcon;
      case 'updating':
        return hourGlassIcon;
      default:
        return null;
    }
  };

  return (
    <StyledToastContainer>
      {list.map((toast, i) => (
        <StyledToast key={toast.id || i} theme={toast.type}>
          <StyledToastColumn>
            {handleIconByType(toast.type) && (
              <StyledIconAction src={handleIconByType(toast.type)} alt={toast.type} type={toast.type} />
            )}
            <p>{toast.message}</p>
          </StyledToastColumn>

          <StyledToastSeparator />

          <StyledToastColumn>
            {toast.btnTitle && <StyledButton onClick={toast.onClick}>{toast.btnTitle}</StyledButton>}

            {toast.id !== 'outbox-pending' && (
              <StyledCloseBtn src={closeIcon} alt={toast.type} onClick={() => deleteToast(toast.id)} />
            )}
          </StyledToastColumn>
        </StyledToast>
      ))}
    </StyledToastContainer>
  );
};

Toast.propTypes = {
  toastList: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      type: PropTypes.string,
      message: PropTypes.string,
      btnTitle: PropTypes.string,
      onClick: PropTypes.func,
    }),
  ),
  autoDelete: PropTypes.bool,
  dismissTime: PropTypes.number,
};

Toast.defaultProps = {
  toastList: undefined,
};

export { Toast };
